import ChallengeInfo from './ChallengeInfo';

export default ChallengeInfo;
